import styled from "styled-components";
import { IconButton as MuiIconButton, Divider as MuiDivider } from "@material-ui/core";
import { ToggleButton as MuiToggleButton, ToggleButtonGroup as MuiToggleButtonGroup } from "@material-ui/lab";
import { selectionYellow } from "styles/colors";

export const IconButton = styled(MuiIconButton)`
    padding: ${({ theme }) => theme.spacing(1)}px;
`;

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)`
    .MuiToggleButtonGroup-groupedHorizontal {
        border-radius: 50%;
    }
`;

export const ToggleButton = styled(MuiToggleButton)`
    border: none;
    border-radius: 50%;
    padding: ${({ theme }) => theme.spacing(1)}px;
    color: ${({ theme }) => theme.palette.grey[600]};

    &.Mui-selected {
        background-color: ${selectionYellow};
    }
`;

export const Divider = styled(MuiDivider)`
    margin: 0 ${({ theme }) => theme.spacing(0.5)}px;
    height: ${({ theme }) => theme.spacing(2.25)}px;
`;
